import React from 'react';
import MyLineChart from '../MyLineChart/MyLineChart';
import MyPieChart from '../MyPieChart/MyPieChart';



const Dashboard = () => {
    return (
        <div className='container text-center mt-5'>
            <h3>Recharts of Sell and Investment vs Revenue</h3>
            <div className='d-flex justify-content-between mb-5'>
                <MyLineChart></MyLineChart>
                <MyPieChart></MyPieChart>
            </div>


        </div>
    );
};

export default Dashboard;